import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { QuestionMarkCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const STORAGE_KEY = 'showFloatingHelp';

const FloatingHelpButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === null ? true : saved === 'true';
  });
  const [showTooltip, setShowTooltip] = useState(false);

  // Don't show on the help page itself
  const isHelpPage = location.pathname === '/help';

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, isVisible.toString());
  }, [isVisible]);

  const handleClick = () => {
    navigate('/help');
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible || isHelpPage) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex items-center gap-2 pointer-events-auto">
      {showTooltip && (
        <div className="bg-gray-900 text-white text-sm py-2 px-3 rounded-lg shadow-lg animate-fade-in">
          Getting Started Guide
        </div>
      )}
      <div className="relative group">
        <button
          onClick={handleClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onTouchStart={() => setShowTooltip(true)}
          className="w-14 h-14 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center touch-manipulation"
          aria-label="Open Getting Started Guide"
        >
          <QuestionMarkCircleIcon className="w-7 h-7" />
        </button>
        <button
          onClick={handleDismiss}
          className="absolute -top-1 -right-1 w-6 h-6 bg-gray-600 hover:bg-gray-700 active:bg-gray-800 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity touch-manipulation"
          aria-label="Hide help button"
        >
          <XMarkIcon className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

// Export the storage key for use in settings
export const HELP_BUTTON_STORAGE_KEY = STORAGE_KEY;

export default FloatingHelpButton;
